module.exports = __webpack_public_path__ + "static/img/pic2.ce6231c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic2.jpg
// module id = 4OB5
// module chunks = 1